/** Map Asset desk API payloads → Activity Console rows. */

function empLabel(row) {
  return (
    row?.employeeName ||
    row?.employee?.fullName ||
    row?.employee?.name ||
    (row?.employeeId != null ? `Emp #${row.employeeId}` : "—")
  );
}

function empCode(row) {
  return row?.employeeCode || row?.employee?.empCode || row?.employee?.employeeCode || "";
}

export function buildAssetDeskItems(pack = {}) {
  const items = [];

  (pack.pendingRequests || []).forEach((row) => {
    const id = row.id;
    const pending = ["pending", "approved", "reserved"].includes(
      String(row.status || "").toLowerCase()
    );
    items.push({
      requestId: `asset_req_${id}`,
      assetRequestId: id,
      deskMode: "asset_request",
      actionLabel: "Asset Request",
      userName: empLabel(row),
      employeeCode: empCode(row),
      employeeId: row.employeeId,
      status: pending ? "Pending" : String(row.status || "Pending"),
      pendingWith: row.pendingWith || "Asset Admin",
      canAct: pending,
      canApprove: pending,
      submittedAt: row.createdAt,
      updatedAt: row.updatedAt,
      formData: {
        requestNo: row.requestNo,
        reason: row.reason,
        quantity: row.quantity,
        priority: row.priority,
        typeId: row.typeId,
        categoryId: row.categoryId,
      },
      slaDays: 3,
      source: "api",
    });
  });

  (pack.pendingRecoveries || []).forEach((row) => {
    const id = row.id;
    const pending = [
      "pending",
      "inspected",
      "amount_set",
      "approved",
    ].includes(String(row.status || "").toLowerCase());
    items.push({
      requestId: `asset_recovery_${id}`,
      assetRecoveryId: id,
      deskMode: "asset_recovery",
      actionLabel: "Asset Recovery",
      userName: empLabel(row),
      employeeCode: empCode(row),
      employeeId: row.employeeId,
      status: pending ? "Pending" : String(row.status || "Pending"),
      pendingWith: "Asset Admin / F&F",
      canAct: pending,
      canApprove: pending,
      submittedAt: row.createdAt,
      updatedAt: row.updatedAt,
      formData: {
        assetTag: row.asset?.assetTag || row.assetTag,
        recoverableAmount: row.recoverableAmount,
        approvedAmount: row.approvedAmount,
        status: row.status,
      },
      slaDays: 5,
      source: "api",
    });
  });

  (pack.overdueReturns || []).forEach((row) => {
    const id = row.id;
    items.push({
      requestId: `asset_return_${id}`,
      assetAssignmentId: id,
      assetId: row.assetId,
      deskMode: "asset_return",
      actionLabel: "Asset Return",
      userName: empLabel(row),
      employeeCode: empCode(row),
      employeeId: row.employeeId,
      status: "Pending",
      pendingWith: "Employee / Asset Admin",
      canAct: true,
      canApprove: true,
      submittedAt: row.assignedAt || row.createdAt,
      updatedAt: row.updatedAt,
      formData: {
        assetTag: row.asset?.assetTag,
        expectedReturnAt: row.expectedReturnAt,
      },
      slaDays: 2,
      source: "api",
    });
  });

  return items;
}
